var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var PictureFileIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 41,
    glyphHeight: 51
  }), React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M28.0525 4.35775V15.225C28.0525 16.4204 29.0235 17.3984 30.2104 17.3984H36.6842V41.3062C36.6842 43.7079 34.7529 45.6531 32.3684 45.6531H8.63158C6.24711 45.6531 4.31579 43.7079 4.31579 41.3062V8.70463C4.31579 6.30298 6.24711 4.35775 8.63158 4.35775H28.0525ZM8.63158 0.0108672H31.0737V0C31.8613 0 32.595 0.445555 32.9726 1.15192L40.7087 14.7142C40.9029 15.0511 41 15.4206 41 15.8009V41.3062C41 46.1095 37.1374 50 32.3684 50H8.63158C3.86263 50 0 46.1095 0 41.3062V8.70463C0 3.90133 3.86263 0.0108672 8.63158 0.0108672ZM23.7366 25.0055C23.7366 22.6038 25.668 20.6586 28.0524 20.6586C30.4369 20.6586 32.3682 22.6038 32.3682 25.0055C32.3682 27.4071 30.4369 29.3523 28.0524 29.3523C25.668 29.3523 23.7366 27.4071 23.7366 25.0055ZM16.5189 26.4727C17.2095 26.4727 17.8568 26.8313 18.2237 27.429H18.2129L23.3487 35.7098L25.6037 32.6778C25.9813 32.1779 26.5747 31.8737 27.2113 31.8737C27.8479 31.8737 28.4413 32.1671 28.8189 32.6778L32.8326 38.068C33.2966 38.6874 33.3613 39.5024 33.0268 40.1871C32.6924 40.8717 31.991 41.3064 31.2358 41.3064H9.82947C9.09578 41.3064 8.42683 40.9043 8.07078 40.2631C7.71473 39.6111 7.73631 38.8287 8.12473 38.2092L14.8142 27.429C15.181 26.8313 15.8284 26.4727 16.5189 26.4727Z",
    fill: "black"
  }));
};
export var PictureFileIconGlyph = function (props) {
  return React.createElement(PictureFileIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};